export default __webpack_public_path__ + "static/media/Shop.44bf93d1.svg";